import React, { Component } from 'react'
import { InteractiveMap, FlyToInterpolator } from 'react-map-gl'
import PropTypes from 'prop-types'
import { easeCubic } from 'd3-ease'
import { fitToBounds } from './'
import MyMapControls from './MyMapControls'
import MapInfo from './MapInfo'
import PopupLayer from './PopupLayer'
import MarkerLayer from './MarkerLayer'
import AvatarLayer from './AvatarLayer'
import FillOverlay from './FillOverlay'
import ColorPanel from '../ColorPanel/ColorPanel'
import config from '../../config'
import 'mapbox-gl/dist/mapbox-gl.css'
import styles from './Map.css'

const points = []
const { minZoom, maxZoom } = config.map
const settings = {
  dragPan: true,
  dragRotate: false,
  scrollZoom: true,
  touchZoom: true,
  touchRotate: false,
  doubleClickZoom: false,
  minZoom,
  maxZoom,
}

class Map extends Component {
  mapControl = new MyMapControls()

  componentDidMount() {
    window.addEventListener('resize', this.resize)
    this.resize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  resize = () => {
    const { onViewportChange, viewport } = this.props
    // FEATURE: (2) Make map slippy
    onViewportChange({
      ...viewport,
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }

  handleClick = e => {
    console.log(e.lngLat)
    points.push(e.lngLat)
    console.log(JSON.stringify([...points, points[0]]))
  }

  // Checks if viewport fits to bounding box, if not, viewport will be corrected
  // TODO: (3) Move to reducer or selector?
  handleViewportChange = viewport => {
    const { latitude, longitude } = fitToBounds(viewport, this.props.bounds)

    this.props.onViewportChange({
      zoom: viewport.zoom,
      longitude,
      latitude,
    })
  }

  // TODO: (2) Sync style via redux store
  handleStyleChange = ({ layers }) => {
    this.setState({ changedMapStyle: { ...this.props.style, layers } })
  }

  render() {
    const { viewport, style, introMode, transition } = this.props
    const { latitude, longitude, zoom, width, height } = viewport

    // FEATURE: (2) Use deck.gl for marker
    return (
      <InteractiveMap
        {...settings}
        {...viewport}
        transitionDuration={transition ? 1500 : 0}
        transitionInterpolator={new FlyToInterpolator()}
        transitionEasing={easeCubic}
        width={width || window.innerWidth}
        height={height || window.innerHeight}
        mapStyle={style}
        onViewportChange={this.handleViewportChange}
        controller={this.mapControl}
        // onClick={this.handleClick}
        className={styles.Map}
      >
        {config.colorTool && process.env.NODE_ENV === 'development' && (
          <div>
            <MapInfo lat={latitude} lng={longitude} zoom={zoom} />
            <ColorPanel mapStyle={style} onChange={this.handleStyleChange} />
          </div>
        )}
        <FillOverlay show={introMode} />
        <PopupLayer viewport={viewport} />
        {introMode && <AvatarLayer viewport={viewport} multiplier={6} />}
        <MarkerLayer viewport={viewport} />
      </InteractiveMap>
    )
  }
}

Map.propTypes = {
  introMode: PropTypes.bool,
  transition: PropTypes.bool,
  style: PropTypes.object.isRequired,
  bounds: PropTypes.object,
  viewport: PropTypes.object,
  onViewportChange: PropTypes.func,
}

Map.defaultProps = {
  introMode: true,
  bounds: {
    lng: [13.54426, 13.93626],
    lat: [50.82008, 51.16929],
  },
  viewport: {
    latitude: 51.03829298480832,
    longitude: 13.790812665417548,
    zoom: 13,
    width: 1024,
    height: 768,
  },
  onViewportChange: x => x,
}

export default Map
